import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { ReactNode } from 'react';

interface AlertBoxProps {
  triggerButton?: ReactNode;
  title: string;
  description: string | ReactNode;
  cancelBtnLabel?: string;
  confirmBtnLabel?: string;
  cancelBtnClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  confirmBtnClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  warning?: boolean;
  onClick?: () => void;
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
  isLoading?: boolean;
  displayCancelButton?: boolean;
}

const AlertBox = ({
  triggerButton,
  title,
  description,
  cancelBtnLabel,
  confirmBtnLabel,
  cancelBtnClick,
  confirmBtnClick,
  warning,
  open,
  onOpenChange,
  isLoading,
  displayCancelButton = true,
}: AlertBoxProps) => {
  return (
    <div>
      <Dialog open={open} data-testid="alert-dialog" onOpenChange={onOpenChange} modal={true} defaultOpen={open}>
        <DialogTrigger asChild>{triggerButton}</DialogTrigger>
        <DialogContent
          className="sm:max-w-md gap-6"
          onInteractOutside={(e) => {
            e.preventDefault();
          }}
        >
          <DialogHeader>
            <DialogTitle className=" font-semibold text-lg break-all">{title}</DialogTitle>
            <DialogDescription
              className="text-[#71717A] text-sm w-full"
              style={{
                overflowWrap: 'anywhere',
              }}
            >
              {description}
            </DialogDescription>
          </DialogHeader>
          <DialogFooter className="justify-end">
            <div className="flex gap-4 ">
              {displayCancelButton && (
                <DialogClose asChild>
                  <Button
                    size="sm"
                    className={`bg-[#fff] border-[1px] border-bordercolor font-medium text-primary py-2 px-4 rounded-md w-24 hover:bg-[#EDF5FF]  focus:outline-none focus-visible:outline-none`}
                    onClick={cancelBtnClick}
                    data-testid="cancel-button"
                  >
                    {cancelBtnLabel}
                  </Button>
                </DialogClose>
              )}
              {confirmBtnClick && (
                <Button
                  type="button"
                  size="sm"
                  className={`text-[#fff] py-2 font-medium px-4 rounded-md  ${warning ? 'bg-[#D72222] hover:text-white hover:bg-error' : 'bg-primary hover:bg-[#12375C]  hover:text-white'} w-24  focus:outline-none focus-visible:outline-none`}
                  onClick={confirmBtnClick}
                  data-testid="confirm-button"
                  isLoading={isLoading}
                  disabled={isLoading}
                >
                  {confirmBtnLabel}
                </Button>
              )}
            </div>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default AlertBox;
